<script>
  import { router } from '@inertiajs/svelte'

  export let user = {}
  export let errors = {}

  let form = {
    name: user.name || '',
    nickname: user.nickname || '',
    role: user.role || 'user',
    status: user.status || 'active',
    organization_name: user.organization_name || '',
    department: user.department || '',
    team: user.team || '',
    position: user.position || ''
  }

  let isSubmitting = false
  
  function handleSubmit(e) {
    e.preventDefault()
    isSubmitting = true
    
    router.patch(`/admin/users/${user.id}`, { user: form }, {
      onFinish: () => {
        isSubmitting = false
      }
    })
  }
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/users" class="hover:text-primary transition-colors">사용자</a>
    <span>/</span>
    <a href={`/admin/users/${user.id}`} class="hover:text-primary transition-colors">{user.name}</a>
    <span>/</span>
    <span class="text-content">수정</span>
  </div>

  <main class="max-w-2xl">
    <div class="card card-bordered p-8 shadow-md">
      <h1 class="text-h1 text-content mb-6">사용자 정보 수정</h1>
      
      <form on:submit={handleSubmit} class="space-y-6">
        <div class="grid md:grid-cols-2 gap-6">
          <div>
            <label for="name" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">이름</label>
            <input
              type="text"
              id="name"
              bind:value={form.name}
              required
              class="input"
            />
            {#if errors.name}
              <p class="mt-1 text-body2 text-error">{errors.name}</p>
            {/if}
          </div>
          
          <div>
            <label for="nickname" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">닉네임</label>
            <input
              type="text"
              id="nickname"
              bind:value={form.nickname}
              class="input"
            />
          </div>
        </div>
        
        <div class="grid md:grid-cols-2 gap-6">
          <div>
            <label for="role" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">역할</label>
            <select
              id="role"
              bind:value={form.role}
              class="select"
            >
              <option value="user">일반 회원</option>
              <option value="moderator">모더레이터</option>
              <option value="admin">관리자</option>
              <option value="super_admin">최고관리자</option>
            </select>
          </div>
          
          <div>
            <label for="status" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">상태</label>
            <select
              id="status"
              bind:value={form.status}
              class="select"
            >
              <option value="active">활성</option>
              <option value="pending">대기중</option>
              <option value="banned">정지됨</option>
              <option value="dormant">휴면</option>
            </select>
          </div>
        </div>
        
        <hr class="border-default" />
        
        <h2 class="text-title text-content">소속 정보</h2>
        
        <div>
          <label for="organization_name" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">회사/기관명</label>
          <input
            type="text"
            id="organization_name"
            bind:value={form.organization_name}
            class="input"
          />
        </div>
        
        <div class="grid md:grid-cols-3 gap-6">
          <div>
            <label for="department" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">부서</label>
            <input
              type="text"
              id="department"
              bind:value={form.department}
              class="input"
            />
          </div>

          <div>
            <label for="team" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">팀</label>
            <input
              type="text"
              id="team"
              bind:value={form.team}
              class="input"
            />
          </div>
          
          <div>
            <label for="position" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">직책</label>
            <input
              type="text"
              id="position"
              bind:value={form.position}
              class="input"
            />
          </div>
        </div>
        
        <div class="flex items-center justify-end gap-4 pt-4">
          <a
            href={`/admin/users/${user.id}`}
            class="btn btn-secondary btn-md"
          >
            취소
          </a>
          <button
            type="submit"
            disabled={isSubmitting}
            class="btn btn-primary btn-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? '저장 중...' : '저장'}
          </button>
        </div>
      </form>
    </div>
  </main>
